import React, { useState, useRef, useEffect } from 'react';
import { Helmet } from "react-helmet"; 
import './word-counter.css';
import { Toast } from '../../components_root/ToastContext';
import { MdClear, MdCopyAll } from 'react-icons/md';
export const seo = {
    title: "Free Word Counter Tool Online | Count Words, Characters, Sentences, Lines & Reading Time",
    description: "Use our free online word counter tool to count words, characters, sentences, lines, and estimate reading time instantly. Perfect for writers, students, and bloggers.",
    keywords: "word counter, free word counter, online word count, character counter, sentence counter, line counter, reading time calculator, text analyzer",
    url: "https://viabig.com/word-counter",
    image: "https://viabig.com/assets/word-counter-preview.png"
};

export default function Word_counter() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const wordCount = text.trim() ? text.trim().split(/\s+/).length : 0;
    const charCount = text.length;
    const lineCount = text ? text.split(/\r\n|\r|\n/).filter(line => line.trim().length > 0).length : 0;
    const textareaRef = useRef(null);
    const sentenceCount = text
        ? text.split(/(?<=[.!?])\s+/).filter(s => s.trim().length > 0).length
        : 0;
    const readingTime = Math.ceil(wordCount / 200); // avg 200 WPM

    const handleClear = () => setText("");

    const handleCopy = () => {
        navigator.clipboard.writeText(text);
        Toastshow("Text copied to clipboard ✅");
    };
    // 🔹 Auto resize textarea on input
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // reset first
            textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
        }
    }, [text]);
    return (
        <div>
          
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size p-3">
                    <h2 className="text-xl font-bold mb-4">Free Online Word Counter</h2>
                    <p className="mb-3">Paste or type your text below to count words, characters, sentences, and reading time instantly.</p>

                    <textarea
                        ref={textareaRef}
                        className="textarea-input"
                        placeholder="Start typing or paste text here..."
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                    />
                    <div className='post-container'>
                        <div className="ui-grid-100">
                            <div className="ui-items items-back-fill text-h2 center p-2">Words: <strong>{wordCount}</strong></div>
                            <div className="ui-items items-back-fill text-h2 center p-2">Characters: <strong>{charCount}</strong></div>
                            <div className="ui-items items-back-fill text-h2 center p-2">Sentences: <strong>{sentenceCount}</strong></div>
                            <div className="ui-items items-back-fill text-h2 center p-2">Lines: <strong>{lineCount}</strong></div>
                            <div className="ui-items items-back-fill text-h2 center p-2">Time: <strong>{readingTime} min</strong></div>
                        </div>
                    </div>
                    <div className="action-buttons">
                        <div className="button-ui p-3 m-2" onClick={handleClear}><MdClear className='icon' /> Clear Text</div>
                        <div className="button-ui p-3 m-2" onClick={handleCopy}><MdCopyAll className='icon' /> Copy Text</div>
                    </div>
                </div>
            </div>

           
            
        </div>
    );
}
